module.exports = __webpack_public_path__ + "img/alert_check.05285a57.svg";